/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from 'react';
import Notes from "./BookDetailsComponents/Notes";
import urlHelper from "../../../_helpers/url.format.server.helper";
import config from "../../../config";
import AxiosClient from "../../../_helpers/http.helper";
import {Select} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import PrintPriceModal from "./BookDetailsComponents/PrintPriceModal";
import {BINDING_TYPES, PAGE_ORIENTATION, PAPER_TYPES, PAPER_WEIGHTS, PERMISSIONS} from "../../constants/constants";


const titleWithChapterWordAndChapterNumbers = 'TitleWithChapterWordAndChapterNumbers';
const titleWithOnlyChapterNumbers = 'TitleWithOnlyChapterNumbers';
const titleWithoutChapterNumbers = 'TitleWithoutChapterNumbers';


export default class BookDetails extends Component {
    constructor(props){
        super(props);
        this.state = {
            showPriceModal: false,
            selectedRadio : "calculated",
            priceAdminUpdateDTO:{
                basePrice: "",
                calculatedPrice: "",
                calculatedPriceAmount: "",
                discountPercent: "",
                permissions: "",
                priceGroupId: "",
                productionCosts: "",
                royalties: "",
                specialPrice: "",
            }
        };
    }
    getOverridePrice() {
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.getOverridePrice,
            {
                collectionId: this.props.match.params.collId
            }
        );
        AxiosClient.get(url)
            .then(response => {
                this.setState({
                    priceAdminUpdateDTO: {
                        basePrice: (response.data.basePrice).toFixed(2),
                        royalties: response.data.royalties ? (response.data.royalties).toFixed(2) : "",
                        permissions: response.data.permissions ? (response.data.permissions).toFixed(2) : "",
                        productionCosts: response.data.productionCosts ? (response.data.productionCosts).toFixed(2) : "",
                        calculatedPrice: response.data.calculatedPrice,
                        specialPrice: response.data.specialPrice ? (response.data.specialPrice).toFixed(2) : "",
                        calculatedPriceAmount: response.data.calculatedPriceAmount ?
                            (response.data.calculatedPriceAmount).toFixed(2):(response.data.basePrice).toFixed(2),
                        discountPercent: response.data.discountPercent ? response.data.discountPercent : 0
                    },
                    selectedRadio : response.data.specialPrice ? "special" : "calculated",
                });
                return response.data;
            })
            .catch(error => {
                console.log("Error ", error);
            });
    }

    componentDidMount(){
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("BookDetails");
        }
        this.props.options.fetchNotes();
        this.fetchBookDetails();
        this.props.guardDirtySetActive(false);
        this.getOverridePrice();
    }

    getPaperWeights = () => {
        const weights = [];
        PAPER_WEIGHTS.forEach((item) => {
            weights.push(item.name);
        });
        return weights;
    };


    getBindingTypes = () => {
        const types = [];
        BINDING_TYPES.forEach((item) => {
            types.push(item.name);
        });
        return types;
    };

    getPaperTypes = () => {
        const types = [];
        this.props.options.paperTypes.forEach((item) => {
            types.push(item.specificationDetail.name);
        });
        return types;
    };


    getCurrentChapterPrefix = (type) => {
        switch(type){
            case titleWithChapterWordAndChapterNumbers: return  "Chapter & Number";
            case titleWithOnlyChapterNumbers : return  "Number Only";
            case titleWithoutChapterNumbers : return  "None";
        }

    };

    getCurrentChapterPrefixLabel = (type) => {
        switch(type){
            case "Chapter & Number": return titleWithChapterWordAndChapterNumbers;
            case "Number Only": return titleWithOnlyChapterNumbers;
            case "None": return titleWithoutChapterNumbers;
        }

    };

    updateTitleHandler = (e) => {
        this.props.options.changeCollectionTitle(e.currentTarget.value,true);
    };

    updateColorHandler = (evt) => {
        this.props.options.changePrintColorSetting(evt.currentTarget.id,true);
    };

    updatePaperWeightHandler = (e) => {
        this.props.options.changePaperWeight(e.currentTarget.value,true);
    };

    updateBindingTypeHandler = (e) => {
        this.props.options.changeSelectedBindingType(e.currentTarget.value,true);
    };

    updatePaperTypeHandler = (e) => {
        this.props.options.changeSelectedPaperType(e.currentTarget.value,true);
    };

    changeChapterPrefixDropDown = (event) => {
        this.props.options.changePrintTOCChapterType(this.getCurrentChapterPrefixLabel(event.target.value),true);
    };


    updateAutomaticPageNumberingHandler = ((event) => {
        event.preventDefault();
        this.props.options.changeAutomaticPageNumbering(event.currentTarget.checked,true);
    });

    updateAutomaticIndexesHandler = ((event) => {
        event.preventDefault();
        this.props.options.changeAutomaticIndexes(event.currentTarget.checked,true);
    });


    updateForcedRectoHandler = ((event) => {
        event.preventDefault();
        this.props.options.changeForcedRectoStart(event.currentTarget.checked,true);
    });

    fetchBookDetails = () => {

        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.bookdetails,
            {
                collectionId: this.props.match.params.collId
            }
        );
        AxiosClient.get(url)
            .then(response => {

                this.props.options.changeAutomaticPageNumbering(response.data.automaticPageNumbering);
                this.props.options.changeAutomaticIndexes(response.data.automaticIndexes);
                this.props.options.changeForcedRectoStart(response.data.forcedRectoStart);
                this.props.options.changePrintColorSetting(response.data.printColorSetting);
                this.props.options.changePrintTOCChapterType(response.data.printTOCChapterType);
                this.props.options.syncPageCount(response.data.pageCount);
                this.props.options.bookDetails.trimSize = response.data.trimSize;
            })
            .catch(error => {
                console.log("Error ", error);
            });
    };

    showPriceModal = () => {
        this.setState({showPriceModal : true});
    };

    hidePriceModal = () => {
        this.setState({
            showPriceModal : false
        });
        this.getOverridePrice();
    };

    setPriceObject = (priceObj) => {
        this.setState({
            priceObj: priceObj
        });
    };


    render(){
        const {closeModal, loadCollection, loadInitialData, collection, getCollectionFromId} = this.props;
        return (<div className="book-details-page">
            <div className="notes">
                {this.props.options.collectionNotes
                && <Notes activeCollection={this.props.collection} holds={this.props.options.collectionNotes.holds}
                    notes={this.props.options.collectionNotes.collectionNoteDTOS} fetchNotes={this.props.options.fetchNotes}
                    showNoteModal={this.props.options.showNoteModal} hideNoteModal={this.props.options.hideNoteModal}
                    loadCurrentHoldsStatus={this.props.options.loadCurrentHoldsStatus} readOnly={this.props.permissions.includes(PERMISSIONS.view_only_notes)}/>
                }
            </div>
            <h6>Book Details</h6>
            <div className="title-group">
                <div className="title">
                    <label className="pe-textLabelInput__label" htmlFor="title">Collection Title</label>
                    <input type="text" className="pe-textInput--basic" id="title" onChange={this.updateTitleHandler}
                        value={this.props.options.bookDetails.title}  disabled={this.props.permissions.includes(PERMISSIONS.view_only_collection_title)}/>
                </div>
            </div>
            {this.props.options.bookDetails && <div className="pe-form--group color">
                <label className="pe-textLabelInput__label">Print Type (Auto)</label>
                <input type="radio" name="color-type" id="Color"
                    checked={this.props.options.bookDetails.printColorSetting === "Color"}
                    onClick={this.updateColorHandler} disabled={!(this.props.options.bookDetails.printColorSetting === "Color") && this.props.permissions.includes(PERMISSIONS.view_only_print_type)}/><label>4-Color</label>
                <input type="radio" name="color-type" id="SingleColor"
                    checked={this.props.options.bookDetails.printColorSetting === "SingleColor"}
                    onClick={this.updateColorHandler} disabled={!(this.props.options.bookDetails.printColorSetting === "SingleColor") && this.props.permissions.includes(PERMISSIONS.view_only_print_type)}/><label>1-Color</label>
            </div>
            }
            <div className="pe-form--group toc">
                { this.props.options.bookDetails.printTOCChapterType !== "" && <Select id="toc"
                    labelText="TOC Numeration"
                    changeHandler={this.changeChapterPrefixDropDown}
                    selectedOption = {this.getCurrentChapterPrefix(this.props.options.bookDetails.printTOCChapterType)}
                    options={["Select","Chapter & Number","Number Only","None"]}
                    inputState={this.props.permissions.includes(PERMISSIONS.view_only_toc_numeration)?"disabled":''}
                />}
            </div>
            <div className="page-numbering">
                <label htmlFor="page-numbering" className={this.props.collection.unscrubbed?"disabled":""} >
                    <input disabled={this.props.collection.unscrubbed} type="checkbox" key={this.props.options.bookDetails.automaticPageNumbering + "page-numbering"}
                        id="page-numbering" checked={this.props.options.bookDetails.automaticPageNumbering}
                        onChange={this.updateAutomaticPageNumberingHandler} disabled={this.props.permissions.includes(PERMISSIONS.view_only_page_numbering)}/> Automatic page numbering
                </label>
            </div>
            <div className="automated-indexes">
                <label htmlFor="automated-indexes" className={this.props.collection.unscrubbed?"disabled":""} >
                    <input type="checkbox"  disabled={this.props.collection.unscrubbed}  key={this.props.options.bookDetails.automaticIndexes + "automated-indexes"}
                        id="automated-indexes" checked={!this.props.collection.unscrubbed && this.props.options.bookDetails.automaticIndexes}
                        onChange={this.updateAutomaticIndexesHandler} disabled={this.props.permissions.includes(PERMISSIONS.view_only_automated_indexes)}/> Automated indexes
                </label>
            </div>
            <div className="forced-recto ">
                <label htmlFor="forced-recto" className={this.props.collection.unscrubbed?"disabled":""} >
                    <input disabled={this.props.collection.unscrubbed} type="checkbox"  key={this.props.options.bookDetails.forcedRectoStart + "forced-recto"}
                        id="forced-recto" checked={ !this.props.collection.unscrubbed && this.props.options.bookDetails.forcedRectoStart}
                        onChange={this.updateForcedRectoHandler}  disabled={this.props.permissions.includes(PERMISSIONS.view_only_forced_recto)}/> Forced-Recto Start
                </label>
            </div>
            <div className="pages">
                <label>Total book pages</label><span className="no-of-pages"> {this.props.options.bookDetails.pageCount}</span>
            </div>
            <div className="price">
                <div className="price-label">
                    <label>{this.props.collection.collectionType} Book
                        ({this.props.collection.geo && this.props.collection.geo.code === "US"? "US": "Canada"} Pricing)
                    </label>
                </div>
                <div className="price-detail">
                    {!this.props.permissions.includes(PERMISSIONS.view_only_print_book_price) ? 
                        <span onClick={this.showPriceModal}>{ this.props.collection.priceModel && <a className="ancorStyle">${
                            (this.props.collection.priceModel.totalPrice).toFixed(2)} </a>}</span> : 
                        <span>{ this.props.collection.priceModel && '$'+(this.props.collection.priceModel.totalPrice).toFixed(2)}</span>}
                    {this.state.showPriceModal && <PrintPriceModal activeCollection={collection}
                        priceAdminUpdateDTO={this.state.priceAdminUpdateDTO}
                        selectedRadio={this.state.selectedRadio}
                        getCollectionFromId={getCollectionFromId}
                        collectionId={this.props.match.params.collId}
                        closeModal={closeModal}
                        loadCollection={loadCollection}
                        loadInitialData={loadInitialData}
                        showPriceModal={this.state.showPriceModal}
                        hidePriceModal = {this.hidePriceModal}
                    />}
                </div>
                {
                    (this.props.collection && this.props.collection.priceModel
                        && this.props.collection.priceModel.priceAdminUpdate
                        && this.props.collection.priceModel.priceAdminUpdate.specialPrice > 0)
                    && <div className="price-message">
                        <label htmlFor="price-message" className="pe-textLabelInput__label price-message">
                            *Special pricing applied
                        </label>
                    </div>
                }
            </div>
            {this.props.collection.geo && this.props.collection.geo.code === 'CA'? (
                <div>
                    <div className="price-label">
                        <label>{this.props.collection.collectionType} Book
                        (US Pricing)
                        </label>
                    </div>
                    <div className="price-detail">
                        {
                            this.props.collection.priceModel.priceGeos.map((price) => {
                                return  price.priceGroup && price.priceGroup.id === '244f7f8e-1e6b-11e4-8276-03d31c1207ee' ? '$'.concat(price.totalPrice) : '';
                            }
                            )
                        }
                    </div>
                </div> ) : ''}
            <div className="pages">
                <label>Trim size: </label><span className="no-of-pages"> {this.props.options.bookDetails.trimSize}</span>
            </div> 
            <div>
                <div className="pe-form--group select-container">
                    {this.props.options.selectedBindingType && <Select id="binding-options"
                        labelText="Binding Type"
                        changeHandler={this.updateBindingTypeHandler}
                        selectedOption={this.props.options.selectedBindingType}
                        options={this.getBindingTypes()}
                        inputState={this.props.permissions.includes(PERMISSIONS.view_only_binding_type)?"disabled":''}
                    />
                    }
                </div>

                <div className="pe-form--group select-container">
                    {this.props.options.selectedPaperType && <Select id="paperOptions"
                        labelText="Paper Type"
                        changeHandler={this.updatePaperTypeHandler}
                        selectedOption={this.props.options.selectedPaperType}
                        options={this.getPaperTypes()}
                        inputState={this.props.permissions.includes(PERMISSIONS.view_only_paper_type)?"disabled":''}
                    /> }
                </div>


                <div className="pe-form--group select-container">{
                    this.props.options.bookDetails.paperWeight && <Select id="paper-weight"
                        labelText="Paper Weight"
                        selectedOption={this.props.options.bookDetails.paperWeight.trim()}
                        changeHandler={this.updatePaperWeightHandler}
                        options={this.getPaperWeights()}
                        inputState={this.props.permissions.includes(PERMISSIONS.view_only_paper_weight)?"disabled":''}
                    />
                }
                </div>
            </div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetails.js